module.exports = __webpack_public_path__ + "1cff53d979dd07111f5188f01c869a0a.svg";